import { render, staticRenderFns } from "./FooterGroupGen.vue?vue&type=template&id=381a0861&scoped=true&"
import script from "./FooterGroupGen.vue?vue&type=script&lang=js&"
export * from "./FooterGroupGen.vue?vue&type=script&lang=js&"
import style0 from "./FooterGroupGen.vue?vue&type=style&index=0&id=381a0861&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "381a0861",
  null
  
)

export default component.exports